/* src/app/modules/notification/components/notification-card/notification-card.component.scss */
.notif-card .notif-main .notif-dot {
  width: 0.5rem;
  height: 0.5rem;
  left: -1rem;
  top: 0.2rem;
}
.notif-card .notif-main .notif-message ::ng-deep p {
  margin: 0;
}
/*# sourceMappingURL=notification-card.component.css.map */
